
import React from 'react';

interface Section {
  id: string;
  label: string;
}

interface CampaignFormActionsProps {
  sections: Section[];
  activeSection: string;
  isSubmitting: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: (e: React.FormEvent) => void;
}

const CampaignFormActions: React.FC<CampaignFormActionsProps> = ({
  sections,
  activeSection,
  isSubmitting,
  onPrevious,
  onNext,
  onSubmit
}) => {
  const currentIndex = sections.findIndex(s => s.id === activeSection);
  const isFirstSection = currentIndex === 0;
  const isLastSection = currentIndex === sections.length - 1;

  const handleSubmitClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onSubmit(e as any);
  };

  return (
    <div className="mt-8 flex justify-between">
      <button
        type="button"
        onClick={onPrevious}
        className={`px-6 py-3 border-2 border-neutral-300 rounded-md text-neutral-700 hover:bg-neutral-50 font-medium transition-colors ${
          isFirstSection ? 'invisible' : ''
        }`}
        disabled={isSubmitting}
      >
        Previous
      </button>
      
      {isLastSection ? (
        <button
          type="submit"
          onClick={handleSubmitClick}
          className="px-8 py-3 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed font-semibold transition-colors"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Launch Analysis'}
        </button>
      ) : (
        <button
          type="button"
          onClick={onNext}
          className="px-6 py-3 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 font-medium transition-colors"
          disabled={isSubmitting}
        >
          Next
        </button>
      )}
    </div>
  );
};

export default CampaignFormActions;
